export const messages = {
  en: {
    adminMeterRecharge: {
      search: {
        title: 'Search Conditions'
      },
      list: {
        title: 'Recharge Details'
      },
      allCommunities: 'All Communities',
      machineName: 'Machine Name',
      machineNamePlaceholder: 'Please enter machine name',
      address: 'Address',
      addressPlaceholder: 'Please enter address',
      state: 'State',
      statePlaceholder: 'Please select recharge state',
      stateWaiting: 'Waiting',
      stateFailed: 'Failed',
      stateCompleted: 'Completed',
      roomName: 'Room',
      roomNamePlaceholder: 'Please enter room number (Building-Unit-Room)',
      startTime: 'Start Time',
      startTimePlaceholder: 'Please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Please enter end time',
      table: {
        communityName: 'Community Name',
        roomName: 'Room',
        typeName: 'Meter Type',
        machineName: 'Meter Name',
        address: 'Meter Number',
        chargeMoney: 'Charge Amount',
        chargeDegrees: 'Charge Degrees',
        createTime: 'Charge Time',
        state: 'Charge State',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch recharge details'
    }
  },
  zh: {
    adminMeterRecharge: {
      search: {
        title: '查询条件'
      },
      list: {
        title: '充值明细'
      },
      allCommunities: '全部小区',
      machineName: '表名称',
      machineNamePlaceholder: '请填写名称',
      address: '表号',
      addressPlaceholder: '请填写表号',
      state: '充值状态',
      statePlaceholder: '请选择充值状态',
      stateWaiting: '等待',
      stateFailed: '失败',
      stateCompleted: '完成',
      roomName: '房屋',
      roomNamePlaceholder: '请填写房屋编号 楼栋-单元-房屋',
      startTime: '开始时间',
      startTimePlaceholder: '请输入开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '请输入结束时间',
      table: {
        communityName: '小区名称',
        roomName: '房屋',
        typeName: '表类型',
        machineName: '表名称',
        address: '表号',
        chargeMoney: '充值金额',
        chargeDegrees: '充值度数',
        createTime: '充值时间',
        state: '充值状态',
remark: '说明'
      },
      fetchError: '获取充值明细失败'
    }
  },
  'zh-TW': {
    adminMeterRecharge: {
      search: {
        title: '查詢條件'
      },
      list: {
        title: '儲值明細'
      },
      allCommunities: '全部小區',
      machineName: '錶名稱',
      machineNamePlaceholder: '請填寫名稱',
      address: '表號',
      addressPlaceholder: '請填寫表號',
      state: '儲值狀態',
      statePlaceholder: '請選擇儲值狀態',
      stateWaiting: '等待',
      stateFailed: '失敗',
      stateCompleted: '完成',
      roomName: '房屋',
      roomNamePlaceholder: '請填寫房屋編號 樓棟-單元-房屋',
      startTime: '開始時間',
      startTimePlaceholder: '請輸入開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '請輸入結束時間',
      table: {
        communityName: '小區名稱',
        roomName: '房屋',
        typeName: '錶類型',
        machineName: '錶名稱',
        address: '表號',
        chargeMoney: '儲值金額',
        chargeDegrees: '儲值度數',
        createTime: '儲值時間',
        state: '儲值狀態',
        remark: '說明'
      },
      fetchError: '獲取儲值明細失敗'
    }
  }
}